import React from "react";
import { Dropdown } from "../../common/components/dropdownSelect";
import { withTipiIntervento } from "../withTipiIntervento";
import { formGroup } from "../../common/components/formGroup";
import { TipoIntervento } from "../../generated";

const DropdownList = Dropdown<TipoIntervento>();
interface Props {
    data: TipoIntervento[],
    value: TipoIntervento,
    onChange: (type: TipoIntervento) => void
    error?: string;
    label?: string;
    onBlur?: React.FocusEventHandler;
    onFocus?: React.FocusEventHandler;
}
class __TipoInterventoSelector extends React.PureComponent<Props>{

    render() {
        const { data, onChange, value, error, label, onBlur, onFocus } = this.props;
        return <DropdownList
            label={label ?? "Tipo intervento"}
            data={data}
            textField={x => x.descTipoIntervento}
            onSelect={onChange}
            value={value}
            error={error}
            onBlur={onBlur}
            onFocus={onFocus}

        />;
    }
}
export const TipoInterventoSelector = formGroup(withTipiIntervento(__TipoInterventoSelector)(x => x.getall(), "data"))

